<div class="sk-m-singleImg"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
            <div class="mainBox">
                {{if style.isShowTitle == '1'}}
                  <% include('../common/title.art', {title: basic.title}) %>
                {{/if}}
                 {{if !content || !content.imgUrl}}
                       <% include('../common/nodata.art') %>
                 {{else}}
                    <div class="sk-m-singleImg">
                        {{if content.linkType != 'none' && !isDesign}}
                        <a class="goto-link" target="_blank" href="{{content.link}}">
                        {{/if}}
                        <img src="{{content.imgUrl}}" alt="" width="100%">
                        {{if content.linkType != 'none' && !isDesign}}
                        </a>
                        {{/if}}
                    </div>
                {{/if}}
            </div>
</div>